export default __webpack_public_path__ + "images/a72f7692f36bf044731e2b8c2b46f690.svg";